import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Badge,
  useTheme,
} from "@mui/material";

import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";

export default function DashboardTopbar({ isMdUp, onOpenMobile }) {
  const theme = useTheme();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: "rgba(6,12,22,0.72)",
        borderBottom: "1px solid rgba(255,255,255,0.10)",
        backdropFilter: "blur(18px)",
        zIndex: (t) => t.zIndex.drawer + 2,
      }}
    >
      <Toolbar sx={{ gap: 1.2, minHeight: 70 }}>
        {!isMdUp && (
          <IconButton
            onClick={onOpenMobile}
            sx={{ color: "rgba(255,255,255,0.92)" }}
          >
            <MenuRoundedIcon />
          </IconButton>
        )}

        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontWeight: 900, letterSpacing: -0.2 }} noWrap>
            Painel do Organizador
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "rgba(255,255,255,0.65)" }}
            noWrap
          >
            Gerencie eventos, vendas e equipe
          </Typography>
        </Box>

        <Box sx={{ flex: 1 }} />

        <IconButton sx={{ color: "rgba(255,255,255,0.92)" }}>
          <Badge variant="dot" color="primary">
            <NotificationsRoundedIcon />
          </Badge>
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
